module.exports = __webpack_public_path__ + "static/media/verified.b8424414.gif";